import hdrm from '../../hdrm';
import site from '../../site';

import actionTypes from '../constants/action-types';
import globals from '../../globals';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

const handleRemoveAttributeAction = (action) => {
  const { elementId, attr, options } = action.payload;
  const { strategy } = options;

  return hdrm.operations.removeElementAttribute(elementId, attr, strategy);
};

const removeElementAttribute = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.BULK_VIEW_ACTIONS: {
      const actions = action.payload.actions.filter(
        (targetAction) => targetAction.type === actionTypes.REMOVE_ELEMENT_ATTRIBUTE
      );

      actions.forEach((targetAction) => {
        handleRemoveAttributeAction(targetAction);
      });

      next(action);
      break;
    }

    case actionTypes.REMOVE_ELEMENT_ATTRIBUTE: {
      const { globalsToUpdate, options } = action.payload;
      const { strategy } = options;

      const newHTML = handleRemoveAttributeAction(action);

      if (strategy !== UPDATE_LIVE_ONLY) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);

        globals.helpers.saveGlobals(globalsToUpdate);
        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next(action);

      break;
    }
    default:
      next(action);
  }
};

export default removeElementAttribute;
